import api from '@/services/api'
import { getOptionsString } from '@/services/api/helpers'
import { getNetworkSummaryDownloadUrl } from '@/services/api/analytics.helpers.js'

const getOrgPodcasts = (options) => {
  let optionsString = getOptionsString(options)
  let path = `/podcasts?${optionsString}`

  return api.get(path).then(async ({data}) => {
    return data
  })
}

const getNetworkSummary = (options) => {
  const path = getNetworkSummaryDownloadUrl(options)
  return api.get(path).then(async ({ data }) => {
    return data
  })
}

const getAppleCredentials = (accountId) => {
  return api.get(`/accounts/${accountId}/apple_credentials`).then(async ({ data }) => {
    return data
  })
}

const createAppleCredentials = (accountId, payload) => {
  return api.post(`/accounts/${accountId}/apple_credentials`, payload).then(async ({ data }) => {
    return data
  }).catch((err) => {
    console.error('Create Apple Credentials Failure:', err)
    throw err
  })
}

export default {
  getOrgPodcasts,
  getNetworkSummary,
  getAppleCredentials,
  createAppleCredentials
}
